import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const getFundData = async (from, to) => {
 
  
  try {
    let url = `/report-list/fundReport`;

    

    if (from) {
      url += `?from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getFundsData = async (from, to) => {
 
  
  try {
    let url = `/report-list/fundData`;

    

    if (from) {
      url += `?from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getRefferalData = async (from, to) => {
 
  
  try {
    let url = `/report-list/refferalData`;

    

    if (from) {
      url += `?from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getProfitData = async (from, to) => {
 
  
  try {
    let url = `/report-list/profitData`;

    

    if (from) {
      url += `?from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getUserData = async (service_number, from, to) => {
 
  
  try {
    let url = `/report-list/userReport`;

    if (service_number) {
      url += `?service_number=${service_number}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getFundsUserData = async (id,from, to) => {
 
  
  try {
    let url = `/report-list/fundData/${id}`;

    

    if (from) {
      url += `?from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getRefferalUserData = async (id,from, to) => {
 
  
  try {
    let url = `/report-list/refferalData/${id}`;

    

    if (from) {
      url += `?from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getProfitUserData = async (id,from, to) => {
 
  
  try {
    let url = `/report-list/profitData/${id}`;

    

    if (from) {
      url += `?from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};
